import React, { useState, useRef } from 'react';
import { mask as masker } from 'remask';
import { Car, Truck, Users } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from "@emailjs/browser";


import { Phone, Mail } from 'lucide-react';

import axios from 'axios';
import Header from "../components/Header"

import { useNavigate } from 'react-router-dom';

const CotAuto = () => {

  const navigate = useNavigate()

  const Swal = require('sweetalert2')

  const modeloveiculoRef = useRef(null)
  const nomeRef = useRef(null)
  const cpfRef = useRef(null)
  const topRef = useRef(null)
  const dadoVeiculoRef = useRef(null)
  const placaRef = useRef(null)
  const tituloDadosVeiculoRef = useRef(null)
  const utilizacaoRef = useRef(null)
  const cepRef = useRef(null)
  const appRef = useRef(null)
  const assRef = useRef(null)
  const cobertura18a25Ref = useRef(null)
  const contatoRef = useRef(null)

  // Função para lidar com a seleção
  const handleSelectType = (type) => {
    const newSelectedType = formData.selectedType === type ? null : type;
    setFormData((prev) => ({
      ...prev,
      selectedType: newSelectedType, // Atualiza o selectedType no formData
    }));
  };

  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    profissao: '',
    estadoCivil: 'Solteiro',
    selectedType: null,
    placa: '',
    chassi: '',
    modeloveiculo: '',
    zeroKm: '',
    anosHabilitacao: '',
    cepPernoite: '',
    residenciaPernoite: 'Apartamento',
    condutorEstudante: '',
    opcoesEstudante: '',
    usaVeiculoTrabalho: '',
    opcoesTrabalho: '',
    danosMateriais: 100000,
    danosCorporais: 100000,
    danosAcidente: 10000,
    carroReserva: '',
    assistencia: '',
    cobertura18a25anos: "",
    sexo18a25: "",
    tipoContato: null, // 'phone' ou 'email'
    telefone: '',
    email: ''
    
  });


  const handleSelectContactType = (type) => {
  const newContactType = formData.tipoContato === type ? null : type;
  setFormData(prev => ({
    ...prev,
    tipoContato: newContactType,
    telefone: '',
    email: ''
  }));
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleMaskChange = (e, mask) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: masker(value, mask),
    });
  };

  const handleRangeChange = (e) => {
    setFormData({
      ...formData,
      danosMateriais: parseInt(e.target.value, 10),
    });
  };
  const handleRangeChange1 = (e) => {
    setFormData({
      ...formData,
      danosCorporais: parseInt(e.target.value, 10),
    });
  };

  const handleRangeChange2 = (e) => {
    setFormData({
      ...formData,
      danosAcidente: parseInt(e.target.value, 10),
    });
  };

  const incrementValue = () => {
    if (formData.danosMateriais < 500000) {
      setFormData({
        ...formData,
        danosMateriais: formData.danosMateriais + 1000,
      });
    }
  };

  const incrementValue1 = () => {
    if (formData.danosCorporais < 500000) {
      setFormData({
        ...formData,
        danosCorporais: formData.danosCorporais + 1000,
      });
    }
  };

  const incrementValue2 = () => {
    if (formData.danosAcidente < 500000) {
      setFormData({
        ...formData,
        danosAcidente: formData.danosAcidente + 1000,
      });
    }
  };

  const decrementValue = () => {
    if (formData.danosMateriais > 0) {
      setFormData({
        ...formData,
        danosMateriais: formData.danosMateriais - 1000,
      });
    }
  };

  const decrementValue1 = () => {
    if (formData.danosCorporais > 0) {
      setFormData({
        ...formData,
        danosCorporais: formData.danosCorporais - 1000,
      });
    }
  };

  const decrementValue2 = () => {
    if (formData.danosAcidente > 0) {
      setFormData({
        ...formData,
        danosAcidente: formData.danosAcidente - 1000,
      });
    }
  };

  const checkMissingData = (formData) => {
    const missingFields = [];
    
    // Lista de campos que não devem ser adicionados, mesmo se estiverem vazios
    const excludedFields = ['opcoesEstudante', 'opcoesTrabalho', 'sexo18a25', 'chassi'];
  
    // Itera sobre cada campo do formData
    for (const [key, value] of Object.entries(formData)) {
      // Verifica se o valor é vazio, null ou undefined e se o campo não está na lista de excluídos
      if ((value === "" || value === null || value === undefined) && !excludedFields.includes(key)) {
        missingFields.push(key); // Adiciona o campo faltante ao array
      }
    }
    
    return missingFields; // Retorna o array com os campos faltantes
  };
  
  const sendEmail = () => {
    const serviceID = "service_0w6d41e"; // Pegue no EmailJS
    const templateID = "template_2nyo9jf"; // Pegue no EmailJS
    const publicKey = "5JBb6YKiWFbtBvFDo"; // Pegue no EmailJS

    const templateParams = {
      user_name: "Nome do Usuário",
      user_email: "email@gmail.com",
      message: `${formData.nome} preencheu o formulário de cotação.`,
    };

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log("Email enviado com sucesso!", response.status, response.text);
  
      })
      .catch((err) => {
        console.error("Erro ao enviar o e-mail:", err);
      });
  };




  async function alertar(e) {
    e.preventDefault();
    //console.log('Dados enviados:', formData);
    // Aqui você pode enviar os dados para o servidor
    

    //const sheetDBUrl = 'https://sheetdb.io/api/v1/9odoxdosnhdu7';
    //const response = await axios.post(sheetDBUrl, { data: [formData] });

    let missingFields = checkMissingData(formData);

    if (missingFields.length > 0) {
      console.log("Campos faltantes:", missingFields[0]);
      //alert(`Os seguintes campos estão faltando: ${missingFields}`);

      if (missingFields[0] === "nome") {

        toast.error(`Informe seu Nome`);
        topRef.current.scrollIntoView({ behavior: "smooth" }); 
    
      }

      if(missingFields[0]  == "cpf"){
        toast.error(`Informe seu CPF`);
        nomeRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "Estado civil"){
        toast.error(`Informe o estado civil`);
        nomeRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "placa"){
        toast.error(`Informe a placa do veículo`);
        dadoVeiculoRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "selectedType"){
        toast.error(`Selecione a utulização do veículo.`);
        tituloDadosVeiculoRef.current.scrollIntoView({ behavior: "smooth" });  
      }
      
      // if(missingFields[0]  == "chassi"){
      //   toast.error(`Informe o chassi do veículo`);
      //   dadoVeiculoRef.current.scrollIntoView({ behavior: "smooth" });  
      // }

      if(missingFields[0]  == "modeloveiculo"){
        toast.error(`Informe o modelo do veículo`);
        placaRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "zeroKm"){
        toast.error(`Informe se o veículo é Zero Km`);
        placaRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "anosHabilitacao"){
        toast.error(`Informe quantos anos o principal condutor é habilitado`);
        placaRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "cepPernoite"){
        toast.error(`Informe o cep de pernoite do veículo`);
        utilizacaoRef.current.scrollIntoView({ behavior: "smooth" });  
      }

      if(missingFields[0]  == "condutorEstudante"){
        toast.error(`Selecione se o condutor é estudante`);  
        cepRef.current.scrollIntoView({ behavior: "smooth" });
       
      }

      if(missingFields[0]  == "opcoesEstudante"){
        if(formData.condutorEstudante == "sim"){
          toast.error(`Selecione o tipo de garagem no local de estudo`);  
          cepRef.current.scrollIntoView({ behavior: "smooth" });
        }else{
          setFormData(prevState => ({
            ...prevState, // Mantém os valores anteriores do estado
            opcoesEstudante: 'Não estuda', // Atribui o novo valor para opcoesEstudante
          }));
          missingFields = checkMissingData(formData);
        }
      }

      if(missingFields[0]  == "usaVeiculoTrabalho"){
        toast.error(`Informe se utiliza o veículo para ir tabalhar`);  
        cepRef.current.scrollIntoView({ behavior: "smooth" });
       
      }

      if(missingFields[0]  == "opcoesTrabalho"){
        if(formData.usaVeiculoTrabalho == "sim"){
          toast.error(`Informe o tipo de garagem no local de serviço`);  
          cepRef.current.scrollIntoView({ behavior: "smooth" });
        }else{
          setFormData(prevState => ({
            ...prevState, // Mantém os valores anteriores do estado
            opcoesTrabalho: 'Não usa para trabalhar', // Atribui o novo valor para opcoesEstudante
          }));
          missingFields = checkMissingData(formData);
        }
        
      }

      if(missingFields[0]  == "carroReserva"){
        toast.error(`Selecione uma opção de carro reserva`);  
        appRef.current.scrollIntoView({ behavior: "smooth" });
       
      }

      if(missingFields[0]  == "assistencia"){
        toast.error(`Selecione uma opção de assistência para seu veículo`);  
        assRef.current.scrollIntoView({ behavior: "smooth" });
       
      }

      if(missingFields[0]  == "cobertura18a25anos"){
        toast.error(`Informe se deseja cobertura para a faixa etária de 18 a 25 anos`);  
        cobertura18a25Ref.current.scrollIntoView({ behavior: "smooth" });
       
      }

      if(missingFields[0]  == "sexo18a25"){
        if(formData.cobertura18a25anos == "sim"){
          toast.error(`Informe o sexo do condutor dessa faixa etária`);  
          cobertura18a25Ref.current.scrollIntoView({ behavior: "smooth" });
        }else{
          setFormData(prevState => ({
            ...prevState, // Mantém os valores anteriores do estado
            sexo18a25: 'Não, sem cobertura', // Atribui o novo valor para opcoesEstudante
          }));
        }
      }


      if (formData.email === "" && formData.telefone === "") {
          toast.error(`Informe um contato para prosseguir`);  
          cpfRef.current.scrollIntoView({ behavior: "smooth" });
      } 


      //alert(missingFields)



    } else {
      console.log("Todos os campos estão preenchidos:", formData);

      const sheetDBUrl = 'https://sheetdb.io/api/v1/9odoxdosnhdu7';
      const response = await axios.post(sheetDBUrl, { data: [formData] });

      //sendEmail()

      console.log(formData)

      navigate("/success")

    }

      if (formData.telefone && formData.email === "") {
          const sheetDBUrl = 'https://sheetdb.io/api/v1/9odoxdosnhdu7';
          const response = await axios.post(sheetDBUrl, { data: [formData] });console.log(formData)
          sendEmail()
          navigate("/success")
      } 

      if (formData.email && formData.telefone === "") {
          const sheetDBUrl = 'https://sheetdb.io/api/v1/9odoxdosnhdu7';
          const response = await axios.post(sheetDBUrl, { data: [formData] });
          sendEmail()
          navigate("/success")
      } 
   
    
  };

  return (
    <>
    <Header />
    <ToastContainer />
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
    {/* <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg p-20">
      <h2>Olá</h2>
    </div> */}
      <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg p-6">
        {/* Logo */}
        {/* <div className="flex justify-center mb-8">
        <img src={Logo} className='w-1/2'/>
        </div> */}

        {/* Formulário */}
        <form className="space-y-8">
          {/* Seção 1: Nome e CPF */}
          <div ref={topRef} className="flex items-center justify-center space-x-2 mb-4">
            <Car className="text-cyan-500 h-6 w-6" />
            <h2 className="text-xl font-bold">Cotação Seguro Auto</h2>
          </div>
          <div className="border-b pb-6">
          
            <div className="space-y-4 max-w-[500px] mx-auto">
              <div ref={nomeRef} >
                <label className="block text-sm font-medium text-gray-700">Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>
              <div ref={cpfRef}>
                <label className="block text-sm font-medium text-gray-700">CPF</label>
                <input
                  type="text"
                  name="cpf"
                  value={formData.cpf}
                  onChange={(e) => handleMaskChange(e, ['999.999.999-99'])}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Profissão</label>
                <input
                  type="text"
                  name="profissao"
                  value={formData.profissao}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Estado Civil:</label>
                <select
                  name="estadoCivil"
                  value={formData.estadoCivil}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                >
                
                  <option value="Solteiro">Solteiro</option>
                  <option value="Casado">Casado</option>
                  <option value="Divorciado">Divorciado</option>
                  <option value="Viúvo">Viúvo</option>
                </select>
              </div>

<div className="space-y-4 max-w-[500px] mx-auto">
  <label className="block text-sm font-medium text-gray-700">
    Deseja receber a cotação por email ou telefone?
  </label>
  
  <div className="flex flex-row space-x-4 justify-center items-center">
    <div
      className={`flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 w-24 sm:w-32 h-24 ${
        formData.tipoContato === "phone"
          ? "border-[#f94b1b] bg-[#f94b1b] bg-opacity-10"
          : "border-gray-300 hover:border-gray-400"
      }`}
      onClick={() => handleSelectContactType("phone")}
    >
      <Phone className="w-6 h-6" />
      <span className="mt-2 text-sm font-medium">WhatsApp</span>
    </div>
    
    <div
      className={`flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 w-24 sm:w-32 h-24 ${
        formData.tipoContato === "email"
          ? "border-[#f94b1b] bg-[#f94b1b] bg-opacity-10"
          : "border-gray-300 hover:border-gray-400"
      }`}
      onClick={() => handleSelectContactType("email")}
    >
      <Mail className="w-6 h-6" />
      <span className="mt-2 text-sm font-medium">E-mail</span>
    </div>
  </div>

  {formData.tipoContato === "phone" && (
    <div className="mt-4">
      <label className="block text-sm font-medium text-gray-700">
        Número do WhatsApp
      </label>
      <input
        type="tel"
        name="telefone"
        value={formData.telefone}
        onChange={(e) => handleMaskChange(e, ['99 9-9999-9999'])}
        placeholder="99 9-9999-9999"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
      />
    </div>
  )}

  {formData.tipoContato === "email" && (
    <div className="mt-4">
      <label className="block text-sm font-medium text-gray-700">
        Endereço de E-mail
      </label>
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="seu@email.com"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
      />
    </div>
  )}
</div>


              {/* final da div */}
            </div>
          </div>

          {/* Seção 2: Placa, Chassi e CEP de Pernoite */}
          <div ref={tituloDadosVeiculoRef} className="border-b pb-6">
            <h2 className="text-2xl md:text-2xl font-semibold text-[#f94b1b] text-center mb-6">Dados do Veículo</h2>


            <div className="space-y-4 max-w-[500px] mx-auto">
            <label className="block text-sm font-medium text-gray-700">Selecione o tipo de utilização do veículo:</label>
            <p className="text-sm text-gray-500 mb-2">Toque na figura abaixo que representa a utilização do veículo:</p>
            <p className="text-sm text-gray-500 mb-2">*Particular caso o veículo seja de uso pessoal tipo ir para o trabalho, viajar...</p>
            <p className="text-sm text-gray-500 mb-2">*Comercial caso o veículo sirva alguma empresa para representação.</p>
            <p ref={dadoVeiculoRef} className="text-sm text-gray-500 mb-2">*Uber/99PoP caso o veículo seja utilizado para táxi ou transporte de aplicativo.</p>


            <div className="flex flex-col justify-center items-center space-y-4 md:flex-row md:space-x-4 md:space-y-0">
            <div className="flex space-x-4">
            {/* Botão para Particular */}
            <div
              className={`flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 w-24 h-24 ${
                formData.selectedType  === "particular"
                ? "border-[#f94b1b] bg-[#f94b1b] bg-opacity-10" // Cor de seleção
                : "border-gray-300 hover:border-gray-400" // Estilo padrão e hover
              }`}
              onClick={() => handleSelectType("particular")}
            >
              <Car />
              <span className="mt-2 text-sm font-medium">Particular</span>
            </div>

            {/* Botão para Comercial */}
            <div
              className={`flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 w-24 h-24 ${
                formData.selectedType  === "comercial"
                ? "border-[#f94b1b] bg-[#f94b1b] bg-opacity-10" // Cor de seleção
                : "border-gray-300 hover:border-gray-400" // Estilo padrão e hover
              }`}
              onClick={() => handleSelectType("comercial")}
            >
              <Truck />
              <span className="mt-2 text-sm font-medium">Comercial</span>
            </div>
            </div>

            {/* Botão para Aplicativo */}
            <div
              className={`flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 w-24 h-24 ${
                formData.selectedType  === "aplicativo"
                ? "border-[#f94b1b] bg-[#f94b1b] bg-opacity-10" // Cor de seleção
                : "border-gray-300 hover:border-gray-400" // Estilo padrão e hover
              }`}
              onClick={() => handleSelectType("aplicativo")}
            >
              <Users />
              <span className="mt-2 text-sm font-medium">Uber/99Pop</span>
            </div>
          </div>


           
              <div ref={placaRef}>
                <label className="block text-sm font-medium text-gray-700">Placa</label>
                <input
                  type="text"
                  name="placa"
                  value={formData.placa}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Chassi</label>
                <input
                  type="text"
                  name="chassi"
                  value={formData.chassi}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

              <div ref={modeloveiculoRef}>
                <label className="block text-sm font-medium text-gray-700">Ano/Versão do Veículo</label>
                <input
                  type="text"
                  name="modeloveiculo"
                  value={formData.modeloveiculo}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Veículo é Zero km?</label>
                <div className="space-y-2">
                  <label className="block">
                    <input
                      type="radio"
                      name="zeroKm"
                      value="sim"
                      checked={formData.zeroKm === 'sim'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Sim
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="zeroKm"
                      value="nao"
                      checked={formData.zeroKm === 'nao'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Não
                  </label>
                </div>


              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Quantos anos o condutor é habilitado?</label>
                <input
                  type="text"
                  name="anosHabilitacao"
                  value={formData.anosHabilitacao}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

            </div>
          </div>

          {/* Seção 3: Utilização */}
          <div ref={utilizacaoRef} className="border-b pb-6">
            <h2 className="text-2xl md:text-2xl font-semibold text-[#f94b1b] text-center mb-6">Utilização</h2>
            <div className="space-y-4 max-w-[500px] mx-auto">
              <div>
                <label className="block text-sm font-medium text-gray-700">Residência que o veículo pernoita é:</label>
                <select
                  name="residenciaPernoite"
                  value={formData.residenciaPernoite}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                >
                
                  <option value="Apartamento">Apartamento</option>
                  <option value="Casa em condomínio fechado">Casa em condomínio fechado</option>
                  <option value="Casa ou sobrado">Casa ou sobrado</option>
                  <option value="Chácara, fazenda ou sítio">Chácara, fazenda ou sítio</option>
                </select>
              </div>

              <div ref={cepRef}>
                <label className="block text-sm font-medium text-gray-700">CEP de Pernoite</label>
                <input
                  type="text"
                  name="cepPernoite"
                  value={formData.cepPernoite}
                  onChange={(e) => handleMaskChange(e, ['99999-999'])}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Condutor é estudante?</label>
                <div className="space-y-2">
                  <label className="block">
                    <input
                      type="radio"
                      name="condutorEstudante"
                      value="sim"
                      checked={formData.condutorEstudante === 'sim'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Sim
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="condutorEstudante"
                      value="nao"
                      checked={formData.condutorEstudante === 'nao'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Não
                  </label>
                </div>
                {formData.condutorEstudante === 'sim' && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700">Tem garagem na faculdade?</label>
                    <div className="space-y-2">
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesEstudante"
                          value="Não"
                          checked={formData.opcoesEstudante === 'Não'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Não tem garagem
                      </label>
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesEstudante"
                          value="Sim, estacionamento pago/fechado"
                          checked={formData.opcoesEstudante === 'Sim, estacionamento pago/fechado'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Sim, estacionamento pago/fechado
                      </label>
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesEstudante"
                          value="Sim, portão eletrônico/porteiro"
                          checked={formData.opcoesEstudante === 'Sim, portão eletrônico/porteiro'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Sim, portão eletrônico/porteiro
                      </label>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Usa o veículo para ir ao trabalho?</label>
                <div className="space-y-2">
                  <label className="block">
                    <input
                      type="radio"
                      name="usaVeiculoTrabalho"
                      value="sim"
                      checked={formData.usaVeiculoTrabalho === 'sim'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Sim
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="usaVeiculoTrabalho"
                      value="nao"
                      checked={formData.usaVeiculoTrabalho === 'nao'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Não
                  </label>
                </div>
                {formData.usaVeiculoTrabalho === 'sim' && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700">No trabalho tem garagem?</label>
                    <div className="space-y-2">
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesTrabalho"
                          value="Não"
                          checked={formData.opcoesTrabalho === 'Não'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Não tem garagem
                      </label>
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesTrabalho"
                          value="Sim, estacionamento pago/fechado"
                          checked={formData.opcoesTrabalho === 'Sim, estacionamento pago/fechado'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Sim, estacionamento pago/fechado
                      </label>
                      <label className="block">
                        <input
                          type="radio"
                          name="opcoesTrabalho"
                          value="Sim, portão eletrônico ou porteiro"
                          checked={formData.opcoesTrabalho === 'Sim, portão eletrônico ou porteiro'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Sim, portão eletrônico ou porteiro
                      </label>
                    </div>
                  </div>
                )}
              </div>
          </div>

          {/* Seção 4: Coberturas */}
          <div className="border-b pb-6 mt-16">
            <h2 className="text-2xl md:text-2xl font-semibold text-[#f94b1b] text-center mb-6">Coberturas</h2>
            <div className="space-y-4 max-w-[500px] mx-auto">
              <div >
                <label className="block text-20 font-medium text-gray-700">Danos materiais a terceiros:</label>
                <p className="text-sm text-gray-500 mb-2">Se acontecer um acidente que envolva os bens de outras pessoas, você conta com uma indenização pra bancar as despesas que tiver com reparos, reposições e até mesmo com advogados, se for o caso.</p>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={decrementValue}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    -
                  </button>
                  <input
                    type="range"
                    name="danosMateriais"
                    min="0"
                    max="500000"
                    step="1000"
                    value={formData.danosMateriais}
                    onChange={handleRangeChange}
                    className="flex-1 h-2 bg-[#f94b1b] rounded-lg appearance-none cursor-pointer"
                    style={{ WebkitAppearance: 'none', appearance: 'none' }}
                  />
                  <button
                    type="button"
                    onClick={incrementValue}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    +
                  </button>
                </div>
                <p className="text-lg font-bold text-[#f94b1b] mt-2">
                  R$ {formData.danosMateriais.toLocaleString()}
                </p>
              </div>

              <div>
                <label className="block text-20 font-medium text-gray-700">Danos corporais a terceiros</label>
                <p className="text-sm text-gray-500 mb-2">Se você se envolver em algum acidente e pessoas ficarem feridas, a gente te ajuda nas despesas necessárias, como: médico-hospitalares e advogados.</p>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={decrementValue1}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    -
                  </button>
                  <input
                    type="range"
                    name="danosMateriais"
                    min="0"
                    max="500000"
                    step="1000"
                    value={formData.danosCorporais}
                    onChange={handleRangeChange1}
                    className="flex-1 h-2 bg-[#f94b1b] rounded-lg appearance-none cursor-pointer"
                    style={{ WebkitAppearance: 'none', appearance: 'none' }}
                  />
                  <button
                    type="button"
                    onClick={incrementValue1}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    +
                  </button>
                </div>
                <p className="text-lg font-bold text-[#f94b1b] mt-2">
                  R$ {formData.danosCorporais.toLocaleString()}
                </p>
              </div>

              <div >
                <label className="block text-20 font-medium text-gray-700">Acidentes de passageiros</label>
                <p className="text-sm text-gray-500 mb-2">Aqui você garante a indenização por morte ou invalidez (permanente, parcial ou total) a todos os passageiros que sofrerem acidentes no seu carro, respeitando a lotação máxima do veículo.</p>
                <div ref={appRef} className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={decrementValue2}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    -
                  </button>
                  <input
                    type="range"
                    name="danosMateriais"
                    min="0"
                    max="500000"
                    step="1000"
                    value={formData.danosAcidente}
                    onChange={handleRangeChange2}
                    className="flex-1 h-2 bg-[#f94b1b] rounded-lg appearance-none cursor-pointer"
                    style={{ WebkitAppearance: 'none', appearance: 'none' }}
                  />
                  <button
                    type="button"
                    onClick={incrementValue2}
                    className="w-6 h-6 bg-[#f94b1b] text-white rounded-full flex items-center justify-center"
                  >
                    +
                  </button>
                </div>
                <p className="text-lg font-bold text-[#f94b1b] mt-2">
                  R$ {formData.danosAcidente.toLocaleString()}
                </p>
              </div>


              <div>
                <label className="block text-20 font-medium text-gray-700">Deseja contratar carro reserva?</label>
                <p className="text-sm text-gray-500 mb-2">O carro reserva é um veículo disponível para uso temporário, fornecido enquanto seu veículo principal sofre um acidente.</p>
                <div className="space-y-2">
                <label className="block">
                    <input
                      type="radio"
                      name="carroReserva"
                      value="07dias"
                      checked={formData.carroReserva === '07dias'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    07 dias
                  </label>

                  <div ref={assRef}></div>
                  <label className="block">
                    <input
                      type="radio"
                      name="carroReserva"
                      value="15dias"
                      checked={formData.carroReserva === '15dias'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    15 dias
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="carroReserva"
                      value="30dias"
                      checked={formData.carroReserva === '30dias'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    30 dias
                  </label>
                  
                  <label className="block">
                    <input
                      type="radio"
                      name="carroReserva"
                      value="não"
                      checked={formData.carroReserva === 'não'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Não
                  </label>

                  
                </div>
              </div>

              <div>
                <label className="block text-20 font-medium text-gray-700">Assintência 24 Horas:</label>
                <p className="text-sm text-gray-500 mb-2">A assistência 24 horas é um serviço oferecido pelas seguradoras que garante o envio de um guincho para o veículo do segurado em casos de imprevistos que impedem a continuidade da viagem ou o funcionamento do carro.</p>
                <div className="space-y-2">
                <label className="block">
                    <input
                      type="radio"
                      name="assistencia"
                      value="200km"
                      checked={formData.assistencia === '200km'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    200 km
                  </label>

                  
                  <label className="block">
                    <input
                      type="radio"
                      name="assistencia"
                      value="400km"
                      checked={formData.assistencia === '400km'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    400 a 600 km
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="assistencia"
                      value="1000km"
                      checked={formData.assistencia === '1000km'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    1.000 km
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="assistencia"
                      value="ilimitado"
                      checked={formData.assistencia === 'ilimitado'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Ilimitado
                  </label>
              <div ref={cobertura18a25Ref}>
                <label className="block text-20 font-medium text-gray-700">Deseja contratar cobertura para condutores de 18 a 25 anos?</label>
                <p className="text-sm text-gray-500 mb-2">Descrição</p>
                <div className="space-y-2">
                <label className="block">
                    <input
                      type="radio"
                      name="cobertura18a25anos"
                      value="sim"
                      checked={formData.cobertura18a25anos === 'sim'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Sim
                  </label>

                  <label className="block">
                    <input
                      type="radio"
                      name="cobertura18a25anos"
                      value="nao"
                      checked={formData.cobertura18a25anos === 'nao'}
                      onChange={handleChange}
                      className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                    />
                    Não
                  </label>
                  {formData.cobertura18a25anos === 'sim' && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700">Condutor dessa faixa a é do sexo:</label>
                    <div className="space-y-2">
                      <label className="block">
                        <input
                          type="radio"
                          name="sexo18a25"
                          value="Masculino"
                          checked={formData.sexo18a25 === 'Masculino'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Masculino
                      </label>
                      <label className="block">
                        <input
                          type="radio"
                          name="sexo18a25"
                          value="Feminino"
                          checked={formData.sexo18a25 === 'Feminino'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Feminino
                      </label>

                      <label className="block">
                        <input
                          type="radio"
                          name="sexo18a25"
                          value="Ambos"
                          checked={formData.sexo18a25 === 'Ambos'}
                          onChange={handleChange}
                          className="mr-2 w-4 h-4 text-[#f94b1b] border-gray-300 rounded focus:ring-[#f94b1b]"
                        />
                        Ambos
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>

                  
                </div>
              </div>

            </div>
          </div>

          {/* Botão de Envio */}
          </div>       
        </form>
              
      </div>
      <div className="mt-6 w-full max-w-[500px]">
            <button
              onClick={alertar}
              className="w-full max-w-[500px] mx-auto bg-[#f94b1b] text-white py-2 px-4 rounded-md shadow-sm hover:bg-[#d18a05]"
            >
              Enviar
            </button>
          </div>
    </div>
    </>
  );
};

export default CotAuto;
